import { belongsTo } from "@ember-data/model";
import JournalEventModel from "parog-web/models/journal-event";

export default abstract class RefundedJournalEvent extends JournalEventModel {
  @belongsTo("reimbursements-retrieved-journal-event", {
    async: false,
    inverse: "actRefundedJournalEvents",
    as: "refunded-journal-event"
  })
  reimbursementsRetrievedJournalEvent;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "refunded-journal-event": RefundedJournalEvent;
  }
}
